import React, { useEffect } from 'react';
import { FaHeart, FaShoppingBag, FaTrash } from 'react-icons/fa';
import WishlistSharing from '../components/WishlistSharing';
import './wishlist.css';
import { setPageMeta } from "../utils/seo";

const Wishlist = ({ wishlist = [], onRemoveFromWishlist, onAddToCart }) => {
  useEffect(() => {
    setPageMeta({
      title: "Wishlist | Banat India",
      description:
        "Save your favorite Banat India products and add them to cart anytime.",
      keywords:
        "wishlist, Banat India favorites, save products, oral care wishlist",
    });
  }, []);

  if (!wishlist || wishlist.length === 0) {
    return (
      <div className="wishlist-empty">
        <FaHeart className="empty-icon" />
        <h2>Your Wishlist is Empty</h2>
        <p>Add items to your wishlist to keep track of products you love!</p>
      </div>
    );
  }

  const totalValue = wishlist.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0);

  return (
    <div className="wishlist-container">
      <div className="wishlist-header">
        <div className="wishlist-title-section">
          <h2 className="wishlist-title">My Wishlist</h2>
          <div className="wishlist-summary">
            <span className="wishlist-count">{wishlist.length} items</span>
            <span className="wishlist-total">Total: ₹{totalValue}</span>
          </div>
        </div>
        
        {/* Wishlist Sharing Component */}
        <div className="wishlist-sharing-container">
          <WishlistSharing wishlist={wishlist} />
        </div>
      </div>

      <div className="wishlist-grid">
        {wishlist.map((item) => (
          <div key={item.id} className="wishlist-item">
            <div className="wishlist-item-image">
              <img 
                src={item.image} 
                alt={item.name}
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/200x200?text=Product';
                }}
              />
            </div>
            <div className="wishlist-item-details">
              <h3 className="wishlist-item-name">{item.name}</h3>
              {item.description && (
                <p className="wishlist-item-description">{item.description}</p>
              )}
              <p className="wishlist-item-price">₹{item.price}</p>
              <div className="wishlist-item-actions">
                <button 
                  className="add-to-cart-btn"
                  onClick={() => onAddToCart(item)}
                >
                  <FaShoppingBag className="action-icon" />
                  Add to Cart
                </button>
                <button 
                  className="remove-btn"
                  onClick={() => onRemoveFromWishlist(item.id)}
                >
                  <FaTrash className="action-icon" />
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty state when all items are removed */}
      {wishlist.length === 0 && (
        <div className="wishlist-empty">
          <FaHeart className="empty-icon" />
          <h2>Your Wishlist is Empty</h2>
          <p>Add items to your wishlist to keep track of products you love!</p>
        </div>
      )}
    </div>
  );
};

export default Wishlist; 